export default "__VITE_ASSET__52ad354d__"